import { render, staticRenderFns } from "./NavSecondaryCustomer.vue?vue&type=template&id=f0920ee8&"
import script from "./NavSecondaryCustomer.vue?vue&type=script&lang=js&"
export * from "./NavSecondaryCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports